import React, { useEffect, useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { UALProvider } from "ual-reactjs-renderer";
import { Helmet } from "react-helmet";
import {
  Modal,
  ModalContent,
  Spinner,
  SpinnerRed,
  SpinnerBlue,
  SpinnerGreen,
  GameButton,
} from "../components/LeftDiv";
import {
  wax,
  anchor,
  myChain,
  currentUsername,
  wombat,
  currentWebsiteURL,
  APP_NAME,
  CONTRACT_NAME,
} from "../data/config";
import {
  MainButton,
  MilestoneContainer,
  MilestoneDescription,
  NewListingBody,
  NewListingCont,
  TallFiltersCont,
  TallFiltersInnerCont,
  theme,
} from "../Styles";


import Error from "../components/Error";

import { useCheckPermissions } from "../components/CustomHooks/useCheckPermissions";
import LoadingPage from "../components/LoadingPage";
import AddPermissionPage from "../components/AddPermissionPage";
import { useGetListingFee } from "../components/CustomHooks/useGetListingFee";
import { createNewListing, handleNftPriceAdd, handleNftPriceOpChange, handleNftPriceQuantityChange, handleNftPriceRemove, handleNftPriceValueChange, handleReceiverAdd, handleReceiverRemove, handleReceiverValueChange, handleTokenPriceAdd, handleTokenPriceOpChange, handleTokenPriceQuantityChange, handleTokenPriceRemove, handleTokenPriceValueChange, handleWhitelistAdd, handleWhitelistRemove, handleWhitelistValueChange } from "../data/functions/create_listing";

const CreateListing = ({ location }) => {
  const {
    enterModalText,
    setEnterModalText,
    loadingDisplay,
    setLoadingDisplay,
    setEnterButtonsDisplay,
    enterModalDisplay,
    setEnterModalDisplay,
  } = useStateContext();

  const [paymentReceivers, setPaymentReceivers] = useState([]);
  const [whitelistRequirements, setWhitelistRequirements] = useState([]);
  const [nftPrices, setNftPrices] = useState({op: 0, quantity: 0, prices: []});
  const [tokenPrices, setTokenPrices] = useState({op: 0, quantity: 0, prices: []});
  const [maxDiscount, setMaxDiscount] = useState(0);


  //custom hooks
  const [hasPermission, getPermission, permissionIsLoading] = useCheckPermissions();
  const [listingFee, getListingFee, feeIsLoading] = useGetListingFee();

  useEffect(() => {
    if(currentUsername){
        getPermission(currentUsername)
    }
  
  }, [])

  useEffect(() => {
    if(currentUsername && !permissionIsLoading && hasPermission){
        getListingFee(currentUsername)
    }
  
  }, [permissionIsLoading, hasPermission])  
  

if(currentUsername && !permissionIsLoading && hasPermission && !feeIsLoading){
    return (
      <div id="seo">
        <Helmet>
          <title>New Listing</title>
          <meta
            name="description"
            content=""
          />
          <link rel="canonical" href={`${currentWebsiteURL}/create-listing`} />
        </Helmet>

        <UALProvider
          chains={[myChain]}
          authenticators={[anchor, wax, wombat]}
          appName={APP_NAME}
        >
          <Modal className={enterModalDisplay}>
            <ModalContent>{enterModalText}</ModalContent>

            <Spinner style={{ display: loadingDisplay }}>
              <SpinnerRed />
              <SpinnerBlue />
              <SpinnerGreen />
            </Spinner>

            <br />
            <GameButton onClick={() => setEnterModalDisplay("hidden")}>
              Close Window
            </GameButton>
          </Modal>

            <NewListingCont>
              <NewListingBody>
                <TallFiltersCont>
                <h2>Create New Listing</h2>
                </TallFiltersCont>
                
                <MilestoneContainer>
                    <MilestoneDescription>
                        You are listing the name <span style={{color: theme.secondary}}>{currentUsername}</span> for sale. This means that users will be able to buy names such as <span style={{color: theme.secondary}}>{`a.${currentUsername}`}</span>
                    </MilestoneDescription>
                </MilestoneContainer>

        <TallFiltersCont>
            <h2>Listing Fee</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                    The fee for this listing is {listingFee} WAX. <a className="italic" href="/faq">How is this calculated?</a>
                </MilestoneDescription>
            </TallFiltersInnerCont>
        </TallFiltersCont>

        <TallFiltersCont>
            <h2>Whitelist Requirements</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                    If you prefer, you can restrict this listing to people holding certain NFTs. These NFTs will stay in the buyer's wallet when they purchase a name.
                </MilestoneDescription>
            </TallFiltersInnerCont>
        </TallFiltersCont>

        {whitelistRequirements.length >= 1 &&
              whitelistRequirements.map((singleW, wIndex) => (
                <TallFiltersCont key={wIndex}>
                  <h2>Requirement {wIndex + 1}</h2>
                  <br />

                  <TallFiltersInnerCont>
                  <h3>Filter By</h3>
                    <select
                      name="filter_by"
                      value={whitelistRequirements[wIndex].filter_by}
                      onChange={(e) => {
                        handleWhitelistValueChange(
                          e,
                          wIndex,
                          whitelistRequirements,
                          setWhitelistRequirements
                        );
                      }}
                    >
                      <option hidden>Choose</option>
                      <option value={0}>Collection</option>
                      <option value={1}>Schema</option>
                      <option value={2}>Template ID</option>
                      </select>

                    <br />
                    <br />

                    <h3>Quantity</h3>
                    <input
                      name="quantity"
                      placeholder="e.g. 3"
                      maxLength={2}
                      value={whitelistRequirements[wIndex].quantity}
                      onChange={(e) => {
                        handleWhitelistValueChange(
                          e,
                          wIndex,
                          whitelistRequirements,
                          setWhitelistRequirements
                        );
                      }}
                    />
                    <br />
                    <br />

                    <h3>Collection Name</h3>
                    <input
                      name="collection_name"
                      placeholder="e.g. hoodpunknfts"
                      maxLength={12}
                      value={whitelistRequirements[wIndex].collection_name}
                      onChange={(e) => {
                        handleWhitelistValueChange(
                          e,
                          wIndex,
                          whitelistRequirements,
                          setWhitelistRequirements
                        );
                      }}
                    />

                    <br />
                    <br />

                    <span className={whitelistRequirements[wIndex].filter_by == 0 && "hidden"}>
                    <h3>Schema Name</h3>
                    <input
                      name="schema_name"
                      placeholder="e.g. wojakpacks"
                      maxLength={12}
                      value={whitelistRequirements[wIndex].schema_name}
                      onChange={(e) => {
                        handleWhitelistValueChange(
                          e,
                          wIndex,
                          whitelistRequirements,
                          setWhitelistRequirements
                        );
                      }}
                    />

                    <br />
                    <br />
                    </span>                    

                    <span className={(whitelistRequirements[wIndex].filter_by == 0 || whitelistRequirements[wIndex].filter_by == 1) && "hidden"}>
                    <h3>Template ID</h3>
                    <input
                      name="template_id"
                      placeholder="e.g. 694201"
                      maxLength={7}
                      value={whitelistRequirements[wIndex].template_id}
                      onChange={(e) => {
                        handleWhitelistValueChange(
                          e,
                          wIndex,
                          whitelistRequirements,
                          setWhitelistRequirements
                        );
                      }}
                    />

                    <br />
                    <br />
                    </span>

                    <div className="text-center w-100">
                      <MainButton
                        onClick={() => {
                          handleWhitelistRemove(
                            setWhitelistRequirements,
                            whitelistRequirements,
                            wIndex
                          );
                        }}
                      >
                        Remove
                      </MainButton>
                    </div>
                  </TallFiltersInnerCont>
                </TallFiltersCont>
              ))}

            {whitelistRequirements.length < 10 && (
              <TallFiltersCont>
                <div className="w-100 text-center pt-3">
                  <MainButton
                    onClick={() => {
                      handleWhitelistAdd(setWhitelistRequirements, whitelistRequirements);
                    }}
                  >
                    Add Whitelist Requirement
                  </MainButton>
                </div>
              </TallFiltersCont>
            )}


            <TallFiltersCont>
            <h2>Prices (Fungible Tokens)</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                   You can accept one or more fungible tokens for this listing.
                </MilestoneDescription>
            </TallFiltersInnerCont>
        </TallFiltersCont>

        {tokenPrices.prices.length >= 1 && (
          <TallFiltersCont>
            <h2>ALL or ANY?</h2>
            <br/>
            <TallFiltersInnerCont>
              <MilestoneDescription>
                Do you want to require ALL of the fungible ingredients you are adding, or only some?
              </MilestoneDescription>
              <br/>
              <h3>Choose</h3>
              <select
                      name="op"
                      value={tokenPrices.op}
                      onChange={(e) => {
                        handleTokenPriceOpChange(
                          e,                          
                          setTokenPrices
                        );
                      }}              
              >
                <option hidden>Choose</option>
                <option value={0}>Some</option>
                <option value={1}>All</option>
              </select>

              <span className={tokenPrices.op == 1 && "hidden"}>
                <br/><br/>
                <MilestoneDescription>
                How many of the fungible requirements does the buyer need to fulfill?
                </MilestoneDescription>
                <br/>
                <h3>Quantity</h3>
                <input 
                      name="quantity"
                      placeholder="e.g. 1"
                      maxLength={2}
                      value={tokenPrices.quantity}
                      onChange={(e) => {
                        handleTokenPriceQuantityChange(
                          e,                          
                          setTokenPrices
                        );
                      }}                   
                />
              </span>
            </TallFiltersInnerCont>

          </TallFiltersCont>
        )}

        {tokenPrices.prices.length >= 1 &&
              tokenPrices.prices.map((singleP, pIndex) => (
                <TallFiltersCont key={pIndex}>
                  <h2>Token Price {pIndex + 1}</h2>
                  <br />

                  <TallFiltersInnerCont>
          
                    <h3>Quantity</h3>
                    <input
                      name="quantity"
                      placeholder="e.g. 420.69"
                      maxLength={16}
                      value={tokenPrices.prices[pIndex].quantity}
                      onChange={(e) => {
                        handleTokenPriceValueChange(
                          e,
                          pIndex,
                          tokenPrices,
                          setTokenPrices
                        );
                      }}
                    />
                    <br />
                    <br />

                    <h3>Token Name</h3>
                    <input
                      name="symbol"
                      placeholder="e.g. WAX"
                      maxLength={7}
                      value={tokenPrices.prices[pIndex].symbol}
                      onChange={(e) => {
                        handleTokenPriceValueChange(
                          e,
                          pIndex,
                          tokenPrices,
                          setTokenPrices
                        );
                      }}
                    />
                    <br />
                    <br />                    

                    <h3>Contract Name</h3>
                    <input
                      name="contract"
                      placeholder="e.g. eosio.token"
                      maxLength={13}
                      value={tokenPrices.prices[pIndex].contract}
                      onChange={(e) => {
                        handleTokenPriceValueChange(
                          e,
                          pIndex,
                          tokenPrices,
                          setTokenPrices
                        );
                      }}
                    />
                    <br />
                    <br />

                    <h3>Token Decimal Places</h3>
                    <input
                      name="precision"
                      placeholder="e.g. 8"
                      maxLength={2}
                      value={tokenPrices.prices[pIndex].precision}
                      onChange={(e) => {
                        handleTokenPriceValueChange(
                          e,
                          pIndex,
                          tokenPrices,
                          setTokenPrices
                        );
                      }}
                    />
                    <br />
                    <br />                    

                    <div className="text-center w-100">
                      <MainButton
                        onClick={() => {
                          handleTokenPriceRemove(
                            setTokenPrices,
                            tokenPrices,
                            pIndex
                          );
                        }}
                      >
                        Remove
                      </MainButton>
                    </div>
                  </TallFiltersInnerCont>
                </TallFiltersCont>
              ))}

            {tokenPrices.prices.length < 10 && (
              <TallFiltersCont>
                <div className="w-100 text-center pt-3">
                  <MainButton
                    onClick={() => {
                      handleTokenPriceAdd(setTokenPrices, tokenPrices);
                    }}
                  >
                    Add Token
                  </MainButton>
                </div>
              </TallFiltersCont>
            )}


            <TallFiltersCont>
            <h2>Prices (NFTs)</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                   You can accept one or more NFTs as payment. You can also filter{" "}
                   by collection, schema, template, or attribute values.
                </MilestoneDescription>
            </TallFiltersInnerCont>
        </TallFiltersCont>

        {nftPrices.prices.length >= 1 && (
          <TallFiltersCont>
            <h2>ALL or ANY?</h2>
            <br/>
            <TallFiltersInnerCont>
              <MilestoneDescription>
                Do you want to require ALL of the NFT ingredients you are adding, or only some?
              </MilestoneDescription>
              <br/>
              <h3>Choose</h3>
              <select
                      name="op"
                      value={nftPrices.op}
                      onChange={(e) => {
                        handleNftPriceOpChange(
                          e,                          
                          setNftPrices
                        );
                      }}              
              >
                <option hidden>Choose</option>
                <option value={0}>Some</option>
                <option value={1}>All</option>
              </select>

              <span className={nftPrices.op == 1 && "hidden"}>
                <br/><br/>
                <MilestoneDescription>
                How many of the NFT requirements does the buyer need to fulfill?
                </MilestoneDescription>
                <br/>
                <h3>Quantity</h3>
                <input 
                      name="quantity"
                      placeholder="e.g. 1"
                      maxLength={2}
                      value={nftPrices.quantity}
                      onChange={(e) => {
                        handleNftPriceQuantityChange(
                          e,                          
                          setNftPrices
                        );
                      }}                   
                />
              </span>
            </TallFiltersInnerCont>

          </TallFiltersCont>
        )}

        {nftPrices.prices.length >= 1 &&
              nftPrices.prices.map((singleP, pIndex) => (
                <TallFiltersCont key={pIndex}>
                  <h2>NFT Price {pIndex + 1}</h2>
                  <br />

                  <TallFiltersInnerCont>
                  <h3>Filter By</h3>
                    <select
                      name="filter_by"
                      value={nftPrices.prices[pIndex].filter_by}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    >
                      <option hidden>Choose</option>
                      <option value={0}>Collection</option>
                      <option value={1}>Schema</option>
                      <option value={2}>Template ID</option>
                      </select>

                    <br />
                    <br />

                    <h3>Quantity</h3>
                    <input
                      name="quantity"
                      placeholder="e.g. 3"
                      maxLength={2}
                      value={nftPrices.prices[pIndex].quantity}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />
                    <br />
                    <br />

                    <h3>Collection Name</h3>
                    <input
                      name="collection_name"
                      placeholder="e.g. hoodpunknfts"
                      maxLength={12}
                      value={nftPrices.prices[pIndex].collection_name}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />

                    <br />
                    <br />

                    <span className={nftPrices.prices[pIndex].filter_by == 0 && "hidden"}>
                    <h3>Schema Name</h3>
                    <input
                      name="schema_name"
                      placeholder="e.g. wojakpacks"
                      maxLength={12}
                      value={nftPrices.prices[pIndex].schema_name}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />

                    <br />
                    <br />
                    </span>                    

                    <span className={(nftPrices.prices[pIndex].filter_by == 0 || nftPrices.prices[pIndex].filter_by == 1) && "hidden"}>
                    <h3>Template ID</h3>
                    <input
                      name="template_id"
                      placeholder="e.g. 694201"
                      maxLength={7}
                      value={nftPrices.prices[pIndex].template_id}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />

                    <br />
                    <br />
                    </span>

                <h3>Distribution Method</h3>
                <select
                        name="distribution_method"
                        value={nftPrices.prices[pIndex].distribution_method}
                        onChange={(e) => {
                          handleNftPriceValueChange(
                            e,
                            pIndex,
                            nftPrices,
                            setNftPrices
                          );
                        }}           
                >
                  <option hidden>Choose</option>
                  <option value={0}>Burn It!</option>
                  <option value={1}>Transfer It</option>
                </select> 
                <br/><br/>    


                    <span className={(nftPrices.prices[pIndex].distribution_method == 0) && "hidden"}>
                    <h3>Transfer It Where?</h3>
                    <input
                      name="wax_address"
                      placeholder="enter wax address"
                      maxLength={13}
                      value={nftPrices.prices[pIndex].wax_address}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />

                    <br />
                    <br />
                    </span>                               
                    
                    <h3>Discount Percentage</h3>
                    <input
                      name="discount_percent"
                      placeholder="e.g 10"
                      maxLength={3}
                      value={nftPrices.prices[pIndex].discount_percent}
                      onChange={(e) => {
                        handleNftPriceValueChange(
                          e,
                          pIndex,
                          nftPrices,
                          setNftPrices
                        );
                      }}
                    />

                    <br />
                    <br />                    

                    <div className="text-center w-100">
                      <MainButton
                        onClick={() => {
                          handleNftPriceRemove(
                            setNftPrices,
                            nftPrices,
                            pIndex
                          );
                        }}
                      >
                        Remove
                      </MainButton>
                    </div>
                  </TallFiltersInnerCont>
                </TallFiltersCont>
              ))}

            {nftPrices.prices.length < 10 && (
              <TallFiltersCont>
                <div className="w-100 text-center pt-3">
                  <MainButton
                    onClick={() => {
                      handleNftPriceAdd(setNftPrices, nftPrices);
                    }}
                  >
                    Add NFT
                  </MainButton>
                </div>
              </TallFiltersCont>
            )}

            <TallFiltersCont>
            <h2>Payment Split</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                   If you are accepting any fungible tokens, you can split them between multiple receivers.{" "}
                   You can also have them added to your balance with us, where you can withdraw them later (or use them for account creation fees, if the token is WAX).
                </MilestoneDescription>
            </TallFiltersInnerCont>
        </TallFiltersCont>

        {paymentReceivers.length >= 1 &&
              paymentReceivers.map((singleReceiver, receiverIndex) => (
                <TallFiltersCont key={receiverIndex}>
                  <h2>Receiver {receiverIndex + 1}</h2>
                  <br />
                  <TallFiltersInnerCont>
                    <h3>WAX Address</h3>
                    <input
                      name="wax_address"
                      placeholder="e.g. mike.wam"
                      maxLength={13}
                      value={paymentReceivers[receiverIndex].wax_address}
                      onChange={(e) => {
                        handleReceiverValueChange(
                          e,
                          receiverIndex,
                          paymentReceivers,
                          setPaymentReceivers
                        );
                      }}
                    />
                    <br />
                    <span className="text-sm italic">
                      *Note: if you put <span style={{color: theme.secondary}}>{CONTRACT_NAME}</span> as the WAX Address, those shares will go directly towards your contract balance.{" "}
                      This balance can be withdrawn at any time. This also means that any WAX received can go directly towards account creation fees, instead of you needing to top up your balance all the time. 
                    </span>
                    <br /><br/>

                    <h3>Shares</h3>
                    <input
                      name="shares"
                      placeholder="e.g. 1"
                      maxLength={3}
                      value={paymentReceivers[receiverIndex].shares}
                      onChange={(e) => {
                        handleReceiverValueChange(
                          e,
                          receiverIndex,
                          paymentReceivers,
                          setPaymentReceivers
                        );
                      }}
                    />

                    <br />
                    <br />

                    <div className="text-center w-100">
                      <MainButton
                        onClick={() => {
                          handleReceiverRemove(
                            setPaymentReceivers,
                            paymentReceivers,
                            receiverIndex
                          );
                        }}
                      >
                        Remove
                      </MainButton>
                    </div>
                  </TallFiltersInnerCont>
                </TallFiltersCont>
              ))}

            {paymentReceivers.length < 10 && (
              <TallFiltersCont>
                <div className="w-100 text-center pt-3">
                  <MainButton
                    onClick={() => {
                      handleReceiverAdd(setPaymentReceivers, paymentReceivers);
                    }}
                  >
                    Add Token Receiver
                  </MainButton>
                </div>
              </TallFiltersCont>
            )}

            <TallFiltersCont>
            <h2>Maximum Discount</h2>
            <br/>
            <TallFiltersInnerCont>
                <MilestoneDescription>
                   If you are allowing any discounts for people who pay with certain NFTs, you can also set a maximum discount percentage for your listing (between 1 and 100).
                </MilestoneDescription>
                <br/>
                <h3>Max Percent Off</h3>
                <input
                  placeholder="e.g. 10"
                  maxLength={3}
                  value={maxDiscount}
                  onChange={(e) => {
                    setMaxDiscount(e.target.value)
                  }}
                 />
            </TallFiltersInnerCont>
        </TallFiltersCont>


        <TallFiltersCont>
            <div className="w-100 text-center items-center mt-2 justify-center">
            <MainButton
                    onClick={() => {
                      createNewListing(listingFee, nftPrices, whitelistRequirements, tokenPrices, 
                        paymentReceivers, maxDiscount,
                        setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay)
                    }}
                >
                    Create Listing
                </MainButton>
            </div>
        </TallFiltersCont>

              </NewListingBody>
              </NewListingCont>

        </UALProvider>
        <br />
        <br />
        <br />
      </div>
    );}
    else if(!currentUsername){
        return(<Error error="You must log in to create a listing" />)
    }
    else if((permissionIsLoading || (!permissionIsLoading && hasPermission && feeIsLoading))){
        return(<LoadingPage />)
    }   
    else if(currentUsername && !permissionIsLoading && !hasPermission){
        return(<AddPermissionPage />)
    }        

};

export default CreateListing;
